import type {TextSectionFragmentType} from '@/modules/page/sanity/content-blocks/text-container/query';

import {INLINE_PORTABLE_TEXT_FRAGMENT} from '../inline-portable-text/query';

export const COLOR_BLOCK_FRAGMENT = `//groq
	_type == "colorBlock" => {
		...,
		content[] {
			...,
			${INLINE_PORTABLE_TEXT_FRAGMENT}
		}
	}
`;

export type ColorBlockFragment = Extract<
	NonNullable<TextSectionFragmentType['content']>[number],
	{_type: 'colorBlock'}
>;
